import styled from "styled-components";
import theme from "../../../../Styles/theme";

export const Container = styled.div`

    display: flex;
    align-items: center;
    justify-content:center;
    flex-direction: column;
    
`;

export const Label = styled.label`

color: ${theme.colors.dark};
cursor: pointer;
&:hover {
        opacity: 0.7;
    }
`;

export const Span = styled.span`
color: ${theme.colors.dark};


padding: 1vh 2vw;
`;

export const Button = styled.button`
    background-color: ${theme.colors.darkGrey};
    color: ${theme.colors.dark};
    &:hover {
        opacity: 0.7;
    }

    padding: 1vh 2vw;
    border-radius: 0.25rem;

`;